const data = {
	"width": 24,
	"height": 24,
	"body": "<path fill=\"currentColor\" d=\"M4 18h5.5v1.25a2.75 2.75 0 1 1-5.5 0V18zM8 6.12c2 0 3 2.88 3 4.88c0 1-.5 2-1 3.5L9.5 16H4c0-1-.5-2.5-.5-5S5.498 6.12 8 6.12zm12.054 7.978l-.217 1.231a2.75 2.75 0 0 1-5.417-.955l.218-1.23l5.416.954zM18.178 1.705c2.464.434 4.018 3.124 3.584 5.586c-.434 2.463-1.187 3.853-1.36 4.838l-5.417-.955l-.232-1.564c-.232-1.564-.55-2.636-.377-3.62c.347-1.97 1.832-4.632 3.802-4.285z\"/>"
};
export default data;
